import { Tabs as MUITabs } from '@material-ui/core';
import { Tab as MUITab } from '@material-ui/core';

export const Tabs = ({ children }, props) => (
    <MUITabs
        {...props}
    >
        {children}
    </MUITabs>
)

export const Tab = (props) => (
    <MUITab {...props}/>
)

